import { AUTH_URL } from "../../urls.api";

export const LOGIN_URL = `${AUTH_URL}/login`;
